import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as AsmgcsActions from "../redux/actions";
import { actions as reduxToolTipActoins } from "react-redux-tooltip";
import sizeMe from "react-sizeme";
import ASMGCS from "../components/widgets/asmgcs";

const config = { monitorHeight: true };

const AppSized = sizeMe(config)(ASMGCS);

const mapStateToProps = (state) => ({
  auth: state.auth,
  airplanes: state.airplanes,
  selectedAirplane: state.activeFlight,
  timeZone: state.SystemParams.timeZone,
  selectedFlights: state.UserInfo.selectedFlights,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showToolTips: reduxToolTipActoins.show,
      hideToolTips: reduxToolTipActoins.hide,
      updateAirplanes: AsmgcsActions.updateAirplanes,
      activateFlight: AsmgcsActions.activateFlight,
      deActivateFlight: AsmgcsActions.deActivateFlight,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(AppSized);
